import { getToken } from "./user-service";
import axios from "axios";

export const getWeather = (iata) => {

    const url = 'api/v1/weather/weather/' + iata
        
    return new Promise(async(resolve, reject) => {
        try {

            const token = await getToken();

            const response = await fetch(url, {
                method: "GET",
                headers: {
                  accept: "application/json",
                  "Content-Type": "application/json",
                  "Firebase-UID": token,
                },
            });

            let json = await response.json();
            
            // check if response is error
            if(response.status >= 400 && response.status < 600){
                throw new Error('error getting weather', response)
            }

            // resolve response
            resolve(json);

        } catch (e) {
            reject(new Error('error getting weather data'))
        }
    })
};
  
export const getImage = (args) => {

    const url = `api/v1/weather/image/${args.flightCode}?imgWidth=${args.imgWidth ? args.imgWidth : 800}&imgHeight=${args.imgHeight ? args.imgHeight : 800}`
        
    return new Promise(async(resolve, reject) => {
        try {

            const token = await getToken();

            const response = await fetch(url, {
                method: "GET",
                headers: {
                  accept: "application/json",
                  "Content-Type": "application/json",
                  "Firebase-UID": token,
                },
            });

            let json = await response.json();

            // check if response is error
            if(response.status >= 400 && response.status < 600){
                throw new Error('error getting SITA Follower API image', response)
            }

            // resolve response
            resolve(json);

        } catch (e) {
            reject(new Error('error getting image'))
        }
    })
};
/*
import { getToken } from "./user-service";
import axios from "axios";

export const getWeather = (iata) => {

    const url = 'api/v1/weather/weather/' + iata
    const token = await getToken();

    const headers = {
        "Firebase-UID": token,
        "accept:": "application/json",
        "Content-Type": "application/json",
    }

    return new Promise(async(resolve, reject) => {
        try {
            const response = await fetch(url, {
                method:'GET',
                headers:headers
            })

            let json = await response.json();

            // check if response is error
            if(response.status >= 400 && response.status < 600){
                throw new Error('error getting weather', response)
            }

            // resolve response
            resolve(json);

        } catch (e) {
            reject(new Error('error getting weather data'))
        }
    })
};
  */
